






























import { Component, Vue } from 'vue-property-decorator';
import { OncallExportTableDesc } from '@/config/map.conf';
import { Form } from '@ss/mtd-vue';
import * as api from '@/api';

const TODAY: Date = new Date(new Date().setHours(0, 0, 0, 0));
// 可查看的最早时间为23年4月
const START_DATE: Date = new Date(2023, 3, 0);

const validateDate: Function = (_rule, value, callback) => {
    if (!value || !value.length) {
        return callback(new Error('日期范围不能为空'));
    }

    const [startDate, endDate] = value.map(date => new Date(date));
    const oneYearLater = new Date(startDate);
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    if (endDate > oneYearLater) {
        return callback(new Error('日期选择范围不能超过一年'));
    }
    return callback();
};

type ExportFormType = 'CHECK_IN_LOG' | 'DUTY_CHANGE_LOG' | 'WORK_TIME_LOG' | 'DUTY_LOG';

interface ExportForm {
    type: ExportFormType;
    desc: string;
    date: Date[];
}

@Component
export default class DataExport extends Vue {
    exportForm: ExportForm = {
        type: 'DUTY_LOG',
        desc: '',
        date: [TODAY, TODAY]
    };
    oncallExportTableDesc: CommonTypes.mapObject = OncallExportTableDesc;
    settingFormRules = {
        date: [{ validator: validateDate }]
    };
    $refs: {
        exportForm: Form;
    };
    loading: boolean = false;
    showProgress: boolean = false;
    downloadProgress: number = 0;
    exportTaskId: number = 0;
    intervalId: number = 0;
    timeoutId: number = 0;
    intervalDuration: number = 5000; // 每5s查询一次
    timeoutDuration: number = 180000; // 首次查询超过3min后取消定时任务

    onFormTypeChanged(val) {
        // 由于 值班表 的可选时间范围与其他表不同，因此如果截止时间超过当天，
        const hasInvalidEndDate = this.exportForm.date[1].getTime() > TODAY.getTime();
        if (val !== 'DUTY_LOG' && hasInvalidEndDate) {
            this.$set(this.exportForm.date, 1, TODAY);
            if (this.exportForm.date[0].getTime() > TODAY.getTime()) {
                this.$set(this.exportForm.date, 0, TODAY);
            }
            this.$refs.exportForm.validate().catch(e => {
                console.log('error: ', e);
            });
        }
    }
    disabledDate(date: Date) {
        // 仅值班表可选时间范围“不”截止到当天所在月
        const notOncallTable = this.exportForm.type !== 'DUTY_LOG';
        const startRule = date.getTime() < START_DATE.getTime();
        const endRule = date.getTime() > TODAY.getTime();
        return notOncallTable ? startRule || endRule : startRule;
    }
    submitDownloadTask() {
        this.$refs.exportForm
            .validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.downloadProgress = 0;
                    this.addOncallExportTask();
                }
            })
            .catch(e => {
                console.log('error: ', e);
            });
    }
    async addOncallExportTask() {
        try {
            const res = await api.oncallApi.addOncallExportTask({
                type: this.exportForm.type,
                rgId: this.rgId,
                startAt: this.formatDateParam(this.exportForm.date[0]),
                endAt: this.formatDateParam(this.exportForm.date[1])
            });
            const { code, data } = res;
            if (code === 200) {
                this.showProgress = true;
                this.exportTaskId = data.taskId;
                this.loading = false;
                this.getExportProgress();
            }
        } catch (error) {
            console.log(error);
            this.loading = false;
        }
    }
    async getExportProgress() {
        try {
            const res = await api.oncallApi.getOncallExportProgress({
                taskId: this.exportTaskId
            });
            const { code, data } = res;
            if (code === 200) {
                if (!this.intervalId) {
                    this.intervalId = setInterval(this.getExportProgress, this.intervalDuration);
                    this.timeoutId = setTimeout(() => {
                        clearInterval(this.intervalId);
                    }, this.timeoutDuration);
                }
                if (data.file) {
                    this.downloadProgress = 100;
                    clearInterval(this.intervalId);
                    this.intervalId = 0;
                    clearTimeout(this.timeoutId);
                    window.open(data.file);
                } else {
                    // 继续轮询
                    this.downloadProgress = data.progress || 0;
                }
            }
        } catch (error) {
            console.log(error);
            // 停止 轮询、停止轮询的定时器
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
        }
    }
    beforeDestory() {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    }
    formatDateParam(date: Date) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份从 0 开始，需要加 1
        const formattedMonth = month < 10 ? `0${month}` : month; // 如果月份小于 10，前面补零
        return `${year}-${formattedMonth}`;
    }
    get dateOptions() {
        return {
            disabledDate: this.disabledDate
        };
    }
    get loadingText() {
        return this.downloadProgress === 100 ? '下载成功！' : `下载中请稍候... ${this.downloadProgress}%`;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
